"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wizardProps = exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useFormApi = _interopRequireDefault(require("@data-driven-forms/react-form-renderer/use-form-api"));

var _wizardContext = _interopRequireDefault(require("@data-driven-forms/react-form-renderer/wizard-context"));

var _get = _interopRequireDefault(require("lodash/get"));

var _set = _interopRequireDefault(require("lodash/set"));

var _flattenDeep = _interopRequireDefault(require("lodash/flattenDeep"));

var _enterHandler = _interopRequireDefault(require("./enter-handler"));

var _reducer = _interopRequireWildcard(require("./reducer"));

var _selectNext = _interopRequireDefault(require("./select-next"));

var _consts = require("./consts");

var _excluded = ["fields", "isDynamic", "crossroads", "Wizard", "component", "initialState"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var Wizard = function Wizard(_ref) {
  var fields = _ref.fields,
      isDynamic = _ref.isDynamic,
      crossroads = _ref.crossroads,
      Wizard = _ref.Wizard,
      component = _ref.component,
      initialState = _ref.initialState,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var formOptions = (0, _useFormApi["default"])();

  var _useReducer = (0, _react.useReducer)(_reducer["default"], _objectSpread(_objectSpread({
    activeStep: fields[0].name,
    prevSteps: [],
    activeStepIndex: 0,
    maxStepIndex: 0
  }, initialState), {}, {
    isDynamic: isDynamic || fields.some(function (_ref2) {
      var nextStep = _ref2.nextStep;
      return _reducer.DYNAMIC_WIZARD_TYPES.includes((0, _typeof2["default"])(nextStep));
    }),
    loading: true
  })),
      _useReducer2 = (0, _slicedToArray2["default"])(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  (0, _react.useEffect)(function () {
    dispatch({
      type: 'finishLoading',
      payload: {
        formOptions: formOptions,
        fields: fields
      }
    });
  }, [fields]);

  if (state.loading) {
    return null;
  }

  var prepareValues = function prepareValues(values, visitedSteps, getRegisteredFields) {
    // Add the final step fields to history
    var finalRegisteredFieldsHistory = _objectSpread(_objectSpread({}, state.registeredFieldsHistory), {}, (0, _defineProperty2["default"])({}, state.activeStep, getRegisteredFields()));

    var finalObject = {}; // Find only visited fields

    (0, _flattenDeep["default"])(Object.values([].concat((0, _toConsumableArray2["default"])(visitedSteps), [state.activeStep]).reduce(function (obj, key) {
      return _objectSpread(_objectSpread({}, obj), {}, (0, _defineProperty2["default"])({}, key, finalRegisteredFieldsHistory[key]));
    }, {}))).forEach(function (key) {
      return (0, _set["default"])(finalObject, key, (0, _get["default"])(values, key));
    });
    return finalObject;
  };

  var onCancel = function onCancel() {
    return formOptions.onCancel(state);
  };

  var handleSubmit = function handleSubmit() {
    return formOptions.onSubmit(prepareValues(formOptions.getState().values, [].concat((0, _toConsumableArray2["default"])(state.prevSteps), [state.activeStep]), formOptions.getRegisteredFields), formOptions, state);
  };

  var jumpToStep = function jumpToStep(index, valid) {
    return dispatch({
      type: 'jumpToStep',
      payload: {
        index: index,
        valid: valid,
        fields: fields,
        crossroads: crossroads,
        formOptions: formOptions
      }
    });
  };

  var handlePrev = function handlePrev() {
    return jumpToStep(state.activeStepIndex - 1);
  };

  var handleNext = function handleNext(nextStep) {
    return dispatch({
      type: 'handleNext',
      payload: {
        nextStep: nextStep,
        formOptions: formOptions,
        fields: fields
      }
    });
  };

  var setPrevSteps = function setPrevSteps() {
    return dispatch({
      type: 'setPrevSteps',
      payload: {
        formOptions: formOptions,
        fields: fields
      }
    });
  };

  var findCurrentStepWrapped = function findCurrentStepWrapped(step) {
    return (0, _reducer.findCurrentStep)(step, fields);
  };

  var onKeyDown = function onKeyDown(e) {
    return (0, _enterHandler["default"])(e, formOptions, state.activeStep, findCurrentStepWrapped, handleNext, handleSubmit);
  };

  return /*#__PURE__*/_react["default"].createElement(_wizardContext["default"].Provider, {
    value: {
      handleNext: handleNext,
      onKeyDown: onKeyDown,
      setPrevSteps: setPrevSteps,
      currentStep: (0, _reducer.findCurrentStep)(state.activeStep, fields),
      jumpToStep: jumpToStep,
      handlePrev: handlePrev,
      formOptions: _objectSpread(_objectSpread({}, formOptions), {}, {
        onCancel: onCancel,
        handleSubmit: handleSubmit
      }),
      navSchema: state.navSchema,
      activeStepIndex: state.activeStepIndex,
      maxStepIndex: state.maxStepIndex,
      isDynamic: state.isDynamic,
      crossroads: crossroads,
      prevSteps: state.prevSteps,
      selectNext: _selectNext["default"]
    }
  }, /*#__PURE__*/_react["default"].createElement(Wizard, props));
};

Wizard.propTypes = {
  fields: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired
  })).isRequired,
  isDynamic: _propTypes["default"].bool,
  crossroads: _propTypes["default"].arrayOf(_propTypes["default"].string),
  Wizard: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func]),
  component: _propTypes["default"].any,
  initialState: _propTypes["default"].object,
  conditionalSubmitFlag: _propTypes["default"].string
};
Wizard.defaultProps = {
  conditionalSubmitFlag: _consts.CONDITIONAL_SUBMIT_FLAG
};
var _default = Wizard;
exports["default"] = _default;
var wizardProps = {
  currentStep: _propTypes["default"].object,
  handlePrev: _propTypes["default"].func,
  onKeyDown: _propTypes["default"].func,
  jumpToStep: _propTypes["default"].func,
  setPrevSteps: _propTypes["default"].func,
  handleNext: _propTypes["default"].func,
  navSchema: _propTypes["default"].array,
  activeStepIndex: _propTypes["default"].number,
  maxStepIndex: _propTypes["default"].number,
  formOptions: _propTypes["default"].shape({
    onCancel: _propTypes["default"].func
  }),
  prevSteps: _propTypes["default"].array
};
exports.wizardProps = wizardProps;